let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4MFmF")).then(() => parcelRequire('j3CaG'));